module.exports = __webpack_public_path__ + "images/stickers/check@2x.7290053d1708576b4baf.png";